import React from "react";
import { CircularProgress } from "@mui/material";
import "./index.scss";

const SelectionTypeList = ({
  className = "",
  types,
  selected,
  setData,
  columns = 1,
  disable = false
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "selection-type-list-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `selection-type-list list-columns-${columns} ${className}`
  }, types.map(el => /*#__PURE__*/React.createElement("div", {
    className: `selection-type-list-item ${selected === el.key ? "active" : ""} ${el.disabled ? "disabled" : ""}`,
    key: el.key,
    onClick: () => {
      if (el.disabled) {
        return;
      }

      setData(el.key);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: el.img,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, el.name)))), /*#__PURE__*/React.createElement("div", {
    className: `selection-type-list-disable ${disable ? "active" : ""}`
  }, /*#__PURE__*/React.createElement(CircularProgress, null)));
};

export default SelectionTypeList;